import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import VariantContainer, {
  IVariantContainerProps,
  IStyleVariant,
} from "../variant-container"
import mergeVariants from "../../util/merge-variants"
import withAnimation from "../../util/withAnimation"

interface IBlockElementProps extends IVariantContainerProps {
  $row?: IStyleVariant
  $col?: IStyleVariant
  $align?: IStyleVariant
  $justify?: IStyleVariant
  $display?: IStyleVariant
}

const BlockElement = styled(VariantContainer)<IBlockElementProps>`
  grid-row: ${(props) => props?.$row?.sm};
  grid-column: ${(props) => props?.$col?.sm};

  display: ${(props) => props?.$display?.sm};
  align-self: ${(props) => props?.$align?.sm};
  justify-self: ${(props) => props?.$justify?.sm};

  @media (min-width: ${Breakpoints.md}) {
    display: ${(props) => props?.$display?.md};
    grid-row: ${(props) => props?.$row?.md};
    grid-column: ${(props) => props?.$col?.md};
    align-self: ${(props) => props?.$align?.md};
    justify-self: ${(props) => props?.$justify?.md};
  }
  @media (min-width: ${Breakpoints.lg}) {
    display: ${(props) => props?.$display?.lg};
    grid-row: ${(props) => props?.$row?.lg};
    grid-column: ${(props) => props?.$col?.lg};
    align-self: ${(props) => props?.$align?.lg};
    justify-self: ${(props) => props?.$justify?.lg};
  }
`

const BaseStyle = css`
  grid-column: 1 / -1;
  width: 100%;
  //display: block;
  box-sizing: border-box;
`
interface IBlockProps {
  [x: string]: any
  align?: any
  col?: any
  display?: {
    sm?: string
    md?: string
    lg?: string
  }
  justify?: any
  row?: any
  variants?: any
  children?: any
}

export const Block = ({
  align,
  col,
  display = { sm: "block" },
  justify,
  row,
  variants,
  children,
  ...rest
}: IBlockProps) => {
  return (
    <BlockElement
      $align={align}
      $col={col}
      $display={display}
      $justify={justify}
      $row={row}
      variants={mergeVariants([BaseStyle], variants)}
      {...rest}
    >
      {children}
    </BlockElement>
  )
}

Block.Animated = withAnimation(Block)

export default Block
